import Service from 'react-reservice';

import { IGeolocation } from '@aqx-core/common/api/geolocation/modal';

export interface IGeolocationContext {
  geolocation: IGeolocation;
  isLoadingGeolocation: boolean;
  isChina: boolean;
  isDoneSettingDomain: boolean;
}

const defaultContext: IGeolocationContext = {
  geolocation: {
    ipAddress: '',
    provider: '',
    country: '',
    forwardedIP: '',
    remoteAddr: ''
  },
  isLoadingGeolocation: false,
  isChina: false,
  isDoneSettingDomain: false
};

class GeolocationService extends Service<IGeolocationContext> {
  constructor() {
    super();
    this.context = defaultContext;
  }

  public setGeolocation = (geolocation: IGeolocation) => {
    this.context.geolocation = geolocation;
  };

  public setIsLoadingGeolocation = (isLoadingGeolocation: boolean) => {
    this.context.isLoadingGeolocation = isLoadingGeolocation;
  };

  public setIsChina = (isChina: boolean) => {
    this.context.isChina = isChina;
  };

  public setIsDoneSettingDomain = (isDoneSettingDomain: boolean) => {
    this.context.isDoneSettingDomain = isDoneSettingDomain;
  };
}

export const geolocationService = new GeolocationService();
